/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  BadRequestErrorResponse,
  PostApiLoginCheck200,
  PostApiLoginCheckBody,
  PostGesdinetJwtRefreshToken200,
  PostGesdinetJwtRefreshTokenBody,
  TooManyLoginAttemptsAuthenticationErrorResponse,
  UnauthorizedLoginErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type postApiLoginCheckResponse200 = {
  data: PostApiLoginCheck200
  status: 200
}

export type postApiLoginCheckResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiLoginCheckResponse401 = {
  data: UnauthorizedLoginErrorResponse
  status: 401
}

export type postApiLoginCheckResponse429 = {
  data: TooManyLoginAttemptsAuthenticationErrorResponse
  status: 429
}
    
export type postApiLoginCheckResponseSuccess = (postApiLoginCheckResponse200) & {
  headers: Headers;
};
export type postApiLoginCheckResponseError = (postApiLoginCheckResponse400 | postApiLoginCheckResponse401 | postApiLoginCheckResponse429) & {
  headers: Headers;
};

export type postApiLoginCheckResponse = (postApiLoginCheckResponseSuccess | postApiLoginCheckResponseError)

export const getPostApiLoginCheckUrl = () => {


  

  return `/api/login-check`
}

export const postApiLoginCheck = async (postApiLoginCheckBody: PostApiLoginCheckBody, options?: RequestInit): Promise<postApiLoginCheckResponse> => {
  
  return customFetch<postApiLoginCheckResponse>(getPostApiLoginCheckUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postApiLoginCheckBody,)
  }
);}


export type getApiLogoutResponse204 = {
  data: void
  status: 204
}
    
export type getApiLogoutResponseSuccess = (getApiLogoutResponse204) & {
  headers: Headers;
};
;

export type getApiLogoutResponse = (getApiLogoutResponseSuccess)

export const getGetApiLogoutUrl = () => {


  

  return `/api/logout`
}

export const getApiLogout = async ( options?: RequestInit): Promise<getApiLogoutResponse> => {
  
  return customFetch<getApiLogoutResponse>(getGetApiLogoutUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postGesdinetJwtRefreshTokenResponse200 = {
  data: PostGesdinetJwtRefreshToken200
  status: 200
}

export type postGesdinetJwtRefreshTokenResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postGesdinetJwtRefreshTokenResponse401 = {
  data: UnauthorizedLoginErrorResponse
  status: 401
}
    
export type postGesdinetJwtRefreshTokenResponseSuccess = (postGesdinetJwtRefreshTokenResponse200) & {
  headers: Headers;
};
export type postGesdinetJwtRefreshTokenResponseError = (postGesdinetJwtRefreshTokenResponse400 | postGesdinetJwtRefreshTokenResponse401) & {
  headers: Headers;
};

export type postGesdinetJwtRefreshTokenResponse = (postGesdinetJwtRefreshTokenResponseSuccess | postGesdinetJwtRefreshTokenResponseError)

export const getPostGesdinetJwtRefreshTokenUrl = () => {


  

  return `/api/token/refresh`
}

export const postGesdinetJwtRefreshToken = async (postGesdinetJwtRefreshTokenBody: PostGesdinetJwtRefreshTokenBody, options?: RequestInit): Promise<postGesdinetJwtRefreshTokenResponse> => {
  
  return customFetch<postGesdinetJwtRefreshTokenResponse>(getPostGesdinetJwtRefreshTokenUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postGesdinetJwtRefreshTokenBody,)
  }
);}


